import { readBuiltInSkillFiles } from "./readSkill.macro" with { type: "macro" };
import { parseSkills } from "./catalog";

export const skillFiles: Record<string, string> = readBuiltInSkillFiles();

export const skills = parseSkills(skillFiles);

export const BUILDING_WORKFLOWS_SKILL = "building-workflows";
